<template>
  <div id="home" class="homeDiv">
    <table width="100%">
      <tr>
        <td class="tc">
          <div>
            <span>
              <h1>
                
              </h1>
            </span>
          </div>
          <br>
          <div>
            <img src="../../../../static/images/home/home_zs.png" style="width:100%; max-width:693px;">
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  },
}
</script>

<style>
  .homeDiv {
    vertical-align: middle;
    display: inline-block;
    width: 100%
  }
</style>



// WEBPACK FOOTER //
// src/views/exhibition/home/Home_ZS.vue